import { render, staticRenderFns } from "./StudentDocuments.vue?vue&type=template&id=06a7ee20&"
import script from "./StudentDocuments.vue?vue&type=script&lang=js&"
export * from "./StudentDocuments.vue?vue&type=script&lang=js&"
import style0 from "./StudentDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports